document.addEventListener("DOMContentLoaded", function () {

  /* ------------------------------
     SHORT DESCRIPTION EXPAND
  --------------------------------*/
  document.querySelectorAll(".product-short-description").forEach(function (wrapper) {
    wrapper.addEventListener("click", function () {
      wrapper.classList.toggle("expanded");
    });
  });

  /* ------------------------------
     PRODUCT JSON
  --------------------------------*/
  const jsonEl = document.getElementById("ProductJson");
  if (!jsonEl) return;

  const productData = JSON.parse(jsonEl.textContent);

  const variantIdInput = document.getElementById("variantId");
  const totalElement   = document.getElementById("dynamicTotal");
  const priceEl        = document.getElementById("productPrice");
  const atcButton      = document.querySelector(".product-add-to-cart");
  const mainImage      = document.querySelector(".product-main-image img");

  let currentVariant =
    productData.variants.find(function (v) {
      return variantIdInput && String(v.id) === String(variantIdInput.value);
    }) || productData.variants[0];

  let basePrice = currentVariant.price / 100;

  /* configured add-to-cart label (fallback if first variant is sold out) */
  const addLabel =
    atcButton && currentVariant.available ? atcButton.textContent.trim() : "Add to Cart";

  function formatMoney(value) {
    return "$" + value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ------------------------------
     PRICE / COMPARE-AT / LIVE REGION (built at runtime, no template edit)
  --------------------------------*/
  let curEl, cmpEl, saveEl, liveEl;
  if (priceEl) {
    priceEl.innerHTML =
      '<span class="pg-price-current"></span>' +
      '<span class="pg-price-compare" hidden></span>' +
      '<span class="pg-price-save" hidden></span>';
    curEl  = priceEl.querySelector(".pg-price-current");
    cmpEl  = priceEl.querySelector(".pg-price-compare");
    saveEl = priceEl.querySelector(".pg-price-save");

    cmpEl.style.cssText  = "text-decoration:line-through;color:#888;margin-left:10px;font-weight:400;font-size:0.8em;";
    saveEl.style.cssText = "margin-left:10px;color:#41617A;font-weight:600;font-size:0.7em;";

    liveEl = document.createElement("span");
    liveEl.className = "visually-hidden";
    liveEl.setAttribute("aria-live", "polite");
    priceEl.insertAdjacentElement("afterend", liveEl);
  }

  function renderPrice(variant) {
    if (!priceEl) return;
    const price   = variant.price / 100;
    const compare = variant.compare_at_price ? variant.compare_at_price / 100 : 0;
    curEl.textContent = formatMoney(price);
    if (compare > price) {
      cmpEl.textContent = formatMoney(compare);
      cmpEl.hidden = false;
      const pct = Math.round(((compare - price) / compare) * 100);
      saveEl.textContent = "Save " + formatMoney(compare - price) + " (" + pct + "%)";
      saveEl.hidden = false;
      priceEl.classList.add("on-sale");
    } else {
      cmpEl.hidden = true;
      saveEl.hidden = true;
      priceEl.classList.remove("on-sale");
    }
  }

  function renderAtc(variant) {
    if (!atcButton) return;
    if (variant.available) {
      atcButton.disabled = false;
      atcButton.textContent = addLabel;
    } else {
      atcButton.disabled = true;
      atcButton.textContent = "Sold Out";
    }
  }

  function announce(variant) {
    if (!liveEl) return;
    liveEl.textContent = (variant.available ? "" : "Sold out. ") + formatMoney(variant.price / 100);
  }

  function pushHistory(variant) {
    if (!history.replaceState) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      history.replaceState({ variant: variant.id }, "", url.toString());
    } catch (e) {}
  }

  /* ------------------------------
     DESKTOP THUMBNAIL GALLERY
  --------------------------------*/
  const thumbs = document.querySelectorAll(".thumb-image");
  thumbs.forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      if (!mainImage) return;
      const full = thumb.dataset.full;
      if (full) {
        mainImage.src = full;
        mainImage.srcset = thumb.dataset.srcset || "";
        if (thumb.dataset.alt) mainImage.alt = thumb.dataset.alt;
      }
      thumbs.forEach(function (t) { t.classList.remove("active"); });
      thumb.classList.add("active");
    });
  });

  /* ------------------------------
     VARIANT SWITCHING
  --------------------------------*/
  const variantButtons = document.querySelectorAll(".variant-btn");
  let selectedOptions = currentVariant.options.slice();

  variantButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (this.disabled) return;
      const optionName = this.dataset.option;
      const wrap = this.closest(".product-variants");
      if (!wrap) return;

      wrap.querySelectorAll('.variant-btn[data-option="' + optionName + '"]').forEach(function (b) {
        b.classList.remove("active");
        b.setAttribute("aria-pressed", "false");
      });
      this.classList.add("active");
      this.setAttribute("aria-pressed", "true");

      const groups = [].slice.call(wrap.querySelectorAll(".variant-buttons"));
      const optionIndex = groups.indexOf(this.parentElement);
      selectedOptions[optionIndex] = this.dataset.value;

      updateVariant();
      updateAvailability();
    });
  });

  function updateVariant() {
    const variant = productData.variants.find(function (v) {
      return v.options.every(function (opt, index) {
        return selectedOptions[index] === opt;
      });
    });
    if (!variant) return;

    currentVariant = variant;
    basePrice = variant.price / 100;
    if (variantIdInput) variantIdInput.value = variant.id;

    renderPrice(variant);
    renderAtc(variant);
    announce(variant);
    pushHistory(variant);
    updateTotal();

    if (variant.featured_image && mainImage) {
      mainImage.src = variant.featured_image.src;
      mainImage.srcset = "";
      thumbs.forEach(function (t) { t.classList.remove("active"); });
    }
  }

  function updateAvailability() {
    variantButtons.forEach(function (btn) {
      const optionValue = btn.dataset.value;
      const optionIndex = productData.options.indexOf(btn.dataset.option);

      const isAvailable = productData.variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[optionIndex] !== optionValue) return false;
        return selectedOptions.every(function (selected, index) {
          if (index === optionIndex) return true;
          if (!selected) return true;
          return v.options[index] === selected;
        });
      });

      if (isAvailable) {
        btn.classList.remove("sold-out");
        btn.disabled = false;
      } else {
        btn.classList.add("sold-out");
        btn.disabled = true;
      }
    });
  }

  /* ------------------------------
     BUNDLE VARIANT SWITCH
  --------------------------------*/
  document.querySelectorAll(".bundle-item").forEach(function (bundle) {
    const variants = JSON.parse(bundle.dataset.variants);
    const selects  = bundle.querySelectorAll("select");
    const hidden   = bundle.querySelector(".bundle-variant-id");

    function updateBundleVariant() {
      let selected = [];
      selects.forEach(function (select, index) {
        selected[index] = select.value;
      });
      const variant = variants.find(function (v) {
        return v.options.every(function (opt, index) {
          return selected[index] === opt;
        });
      });
      if (!variant || !variant.available) {
        if (hidden) hidden.value = "";
        return;
      }
      if (hidden) hidden.value = variant.id;
      const checkbox = bundle.querySelector(".bundle-checkbox");
      if (checkbox) checkbox.dataset.price = variant.price;
      const priceElB = bundle.querySelector(".bundle-price");
      if (priceElB) priceElB.innerText = "$" + (variant.price / 100).toFixed(2);
    }

    selects.forEach(function (select) {
      select.addEventListener("change", updateBundleVariant);
    });
    updateBundleVariant();
  });

  /* ------------------------------
     BUNDLE + GIFT COLLECTION
  --------------------------------*/
  const bundleCheckboxes = document.querySelectorAll(".bundle-checkbox");

  function getBundleItems() {
    let items = [];
    document.querySelectorAll(".bundle-item").forEach(function (bundle) {
      const checkbox = bundle.querySelector(".bundle-checkbox");
      if (checkbox && checkbox.checked) {
        const hiddenVariant = bundle.querySelector(".bundle-variant-id");
        if (!hiddenVariant || !hiddenVariant.value) return;
        items.push({ id: parseInt(hiddenVariant.value, 10), quantity: 1 });
      }
    });
    return items;
  }

  const giftCheckbox = document.getElementById("giftWrap");
  function getGiftItem() {
    if (giftCheckbox && giftCheckbox.checked) {
      return [{ id: giftCheckbox.dataset.variant, quantity: 1 }];
    }
    return [];
  }

  /* ------------------------------
     DYNAMIC TOTAL
  --------------------------------*/
  function updateTotal() {
    let total = basePrice;
    bundleCheckboxes.forEach(function (box) {
      if (box.checked) total += parseFloat(box.dataset.price) / 100;
    });
    if (giftCheckbox && giftCheckbox.checked) {
      total += parseFloat(giftCheckbox.dataset.price) / 100;
    }
    if (totalElement) totalElement.innerText = formatMoney(total);

    const installmentEl = document.getElementById("installmentPrice");
    if (installmentEl) installmentEl.innerText = formatMoney(total / 4);
  }

  bundleCheckboxes.forEach(function (box) {
    box.addEventListener("change", updateTotal);
  });
  if (giftCheckbox) giftCheckbox.addEventListener("change", updateTotal);

  /* ------------------------------
     ADD TO CART (AJAX, bulk + error handling)
  --------------------------------*/
  function openDrawerSafe() {
    if (typeof window.openCartDrawer === "function") {
      window.openCartDrawer();
    } else {
      window.location.href = "/cart";
    }
  }

  function addItemsToCart(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error((err && err.description) || "This item could not be added to your cart.");
        });
      }
      return res.json();
    });
  }

  const form = document.querySelector(".product-form");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (atcButton && atcButton.disabled) return;

      let items = [{ id: variantIdInput.value, quantity: 1 }];
      items = items.concat(getBundleItems());
      items = items.concat(getGiftItem());

      if (atcButton) {
        atcButton.disabled = true;
        atcButton.textContent = "Adding...";
      }

      addItemsToCart(items)
        .then(function () {
          openDrawerSafe();
        })
        .catch(function (err) {
          window.alert(err.message || "Sorry, this item could not be added to your cart.");
        })
        .then(function () {
          if (atcButton) {
            atcButton.disabled = !currentVariant.available;
            atcButton.textContent = currentVariant.available ? addLabel : "Sold Out";
          }
        });
    });
  }

  /* ------------------------------
     STICKY MOBILE ADD TO CART - REMOVED (CWV fix, July 2026)

     This file used to build a second sticky add-to-cart bar at runtime
     (.pg-sticky-atc / .pg-sticky-thumb), injecting its own <style> block and
     appending the bar to <body>. It was superseded by the Liquid snippet
     snippets/oath-sticky-atc.liquid (.oath-sticky-atc), but the old code was
     never deleted, so both bars shipped on every product page.

     Why it mattered:
       - Duplicate UI. Two sticky bars rendered on mobile, the legacy one at
         max-width 749px and the Liquid one below 900px.
       - Wasted bytes. The legacy thumb was sized from
         variant.featured_image.src, which ProductJson emits at width 1200,
         falling back to the main image src at width 800. Either way it loaded
         an 800 to 1200 pixel render into a 44px slot with no width/height
         attributes, no srcset, and no loading attribute, so it fetched
         eagerly. PSI measured 87.5 KiB with 63.2 KiB wasted on
         /products/14kt-yellow-gold-mens-round-cut-diamond-ring.
       - The Liquid replacement already does this correctly: image_url at
         width 120, explicit width and height of 40, loading lazy, and it
         mirrors price and sold-out state from the main buy block via
         MutationObserver.

     NOTE for whoever touches this next: syncSticky() used to be called from
     the end of updateVariant(). That call was removed alongside this block.
     Deleting one without the other throws a ReferenceError inside
     updateVariant and silently breaks variant switching.

     One known behaviour difference, accepted deliberately: the legacy bar
     swapped its thumbnail on variant change. The Liquid snippet renders the
     product's featured image and does not swap. Price and availability still
     track the selected variant.
  --------------------------------*/

  /* ------------------------------
     INITIAL SYNC
  --------------------------------*/
  variantButtons.forEach(function (btn) {
    const idx = productData.options.indexOf(btn.dataset.option);
    if (selectedOptions[idx] === btn.dataset.value) {
      btn.classList.add("active");
      btn.setAttribute("aria-pressed", "true");
    } else {
      btn.classList.remove("active");
      btn.setAttribute("aria-pressed", "false");
    }
  });

  renderPrice(currentVariant);
  renderAtc(currentVariant);
  updateAvailability();
  updateTotal();

});
